import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { Box, Card } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { formActions } from '../../../../actions';
import { APP_SCENE, FORM_CONSTANTS } from '../../../../constants';
import Loading from '../../../../components/CustomComponents/Loading';

function DanhSachThanhTichProfile(props) {
  const dispatch = useDispatch();
  const loadingForm = useSelector(state => state.formReducer.loading);
	const applicationList = useSelector(state => state.formReducer.applicationList);

	const form = applicationList.find((e) => e.id === props.formId);

	useEffect(() => {
		if (form) dispatch(formActions.setFocusForm(form));
	}, [form]);

	// NSKH 2026: thay "Tóm tắt thành tích" bằng các thông tin cá nhân
	const infoList = [
		{ label: 'Giới tính', value: FORM_CONSTANTS.GENDER_OPTIONS.find((e) => e.value === form?.profile?.gender)?.title },
		{ label: 'Dân tộc', value: form?.profile?.ethnic },
		{ label: 'Đoàn thể chính trị', value: FORM_CONSTANTS.POLITICAL_UNION_OPTIONS.find((e) => e.value === form?.politicalUnion)?.title },
		{ label: 'Ngoại ngữ', value: form?.languague },
		{ label: 'Tên trường/học viện đang theo học', value: form?.university },
		{ label: 'Tên Khoa/Viện', value: form?.faculty },
		{ label: 'Sinh viên năm thứ', value: form?.studentYear },
		{ label: 'Ngành học', value: form?.major },
		{ label: 'Nhóm ngành đăng ký', value: FORM_CONSTANTS.FIELD_OPTIONS[APP_SCENE]?.find((e) => e.value === form?.field)?.title },
	];

	return (
		<Card style={{ padding: '4px 16px', minHeight: 'calc(100vh - 114px)' }}>
      <Box display='flex' justifyContent='center' padding={1}>
        <img
          // eslint-disable-next-line no-undef
          src={`${process.env.REACT_APP_DOMAIN}${form?.profile?.photoUrl}`}
          style={{ maxWidth: 120, maxHeight: 150, minHeight: 150, objectFit: 'cover' }}
        />
      </Box>
			<Box style={{ textAlign: 'center' }}><b>{form?.profile?.name}</b></Box>
      <Box style={{ textAlign: 'center' }}><b>Ngày sinh: </b>{dayjs(form?.profile?.birth).format('DD/MM/YYYY')}</Box>
      <Box marginTop={2}>
        {infoList.map((e, index) => (
          <Box key={index} marginTop={0.5}>
            <b>{e.label}: </b>{e.value}
          </Box>
        ))}
      </Box>
      <Loading open={loadingForm} />
    </Card>
	)
}

export default DanhSachThanhTichProfile;
